import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.user.notificationLastResult;
//VERIFY IF THE JWT IS SET
const getNotificationsLastResult = createSelector(
  getData,
  notificationLastResult => notificationLastResult
);
export default getNotificationsLastResult;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getNotificationsLastResult.js